import React from 'react'
import RemoteVUService from '../../services/RemoteVU/RemoteVU.service'
import PropTypes from 'prop-types'
import { trackEvent } from '../../utils/functions'

export const RemoteVUContext = React.createContext()

export const RemoteVUContextProvider = (props) => {
  const [allUsers, setAllUsers] = React.useState([])

  const fetchUsers = React.useCallback(async (portalName, portalOnly = false) => {
    try {
      const res = await RemoteVUService.fetchUsers(portalName, portalOnly)
      setAllUsers(res.data)
    } catch (err) {
      // Error fetching users
    }
  }, [])

  const addUser = React.useCallback(async (
    email,
    userName,
    portalName,
    portalRole,
    isScreenVU = false,
    isGlassvuUser = false,
    isScreenvuUser = false,
    isCamvuUser = false,
    isUserOnboardingRequired = false,
    licenceId
  ) => {
    trackEvent('RemoteVU Added')
    return await RemoteVUService.addUser(
      email,
      userName,
      portalName,
      portalRole,
      isScreenVU,
      isGlassvuUser,
      isScreenvuUser,
      isCamvuUser,
      isUserOnboardingRequired,
      licenceId
    )
  }, [])

  const editUser = React.useCallback(async (
    selectedUserId,
    name,
    role,
    users,
    portalName,
    licenceId
  ) => {
    trackEvent('RemoteVU Edited')
    return await RemoteVUService.editUser(
      selectedUserId,
      name,
      role,
      users,
      portalName,
      licenceId
    )
  }, [])

  const removeUser = React.useCallback(async (email, portalName) => {
    trackEvent('RemoteVU Removed')
    return await RemoteVUService.removeUser(email, portalName)
  }, [])

  const getUser = React.useCallback(async (selectedUserId) => {
    trackEvent('RemoteVU Fetched')
    return await RemoteVUService.getUser(selectedUserId)
  }, [])

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = React.useMemo(
    () => ({ allUsers, fetchUsers, addUser, removeUser, editUser, getUser }),
    [allUsers, fetchUsers, addUser, removeUser, editUser, getUser]
  )

  return (
    <RemoteVUContext.Provider value={contextValue}>
      {props.children}
    </RemoteVUContext.Provider>
  )
}

RemoteVUContextProvider.propTypes = {
  children: PropTypes.node
}
